import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  isShowMenu:boolean =  false;

  constructor(public navCtrl: NavController, public loadingCtrl: LoadingController) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts